import React, { Component } from 'react';
import './styles.css';

class LightGreyCircle extends Component {
	render() {
		return (
			<div className="stepper-item-layout-light-grey-circle">
				{this.props.children}
			</div>
		);
	}
}

export default LightGreyCircle;
